import { ChatMessageTargetType } from '../../enums';
import { IsEnum, IsUUID } from 'class-validator';

export class UpdateLastReadChatMessageDto {
	@IsUUID()
	target_id: string;

	@IsEnum(ChatMessageTargetType)
	target_type: ChatMessageTargetType;

	@IsUUID()
	message_id: string;
}
